import { EventUser } from '../../model/EventUser'
import { http } from '../../utils/http'

export const getEventUsersAsync = async (
    partyEventId: number,
    token: string
) : Promise<EventUser[]> => {
    const result = await http<undefined, EventUser[]>({
        path: `EventUsers?partyEventId=${partyEventId}`,
        accessToken: token
    })
    if (result.ok && result.parsedBody) {
        return result.parsedBody || []
    }
    return []
}

export const deleteEventUserAsync = async (
    partyEventId: number,
    email: string,
    token: string
) : Promise<boolean> => {
    const result = await http<undefined, null>({
       path: `EventUsers?partyEventId=${partyEventId}&email=${email}`,
       accessToken: token,
       method: 'delete'
    })
    return (result.ok)
}